import { Injectable } from '@angular/core';
import { ApiService } from '../common/api/api.service';
import { Observable } from 'rxjs';

import { API_ANALYZE_SELFIE, API_REDIRECT_URL, API_VERIFY_AUTH  } from '../common/api/api-actions';
import { Selfie } from '../../models/selfie.model';
import { FaceMatchResponse } from '../../models/face-match-response.model';
import { DataObject } from '../../models/data.model';

@Injectable({
	providedIn: 'root'
})
export class AppService {

	constructor(
		private api: ApiService
	) { }

	analyzeSelfie(data: Selfie): Observable<FaceMatchResponse> {
		return this.api.post<Selfie, FaceMatchResponse>(API_ANALYZE_SELFIE, data);
	}

	getRedirectUrl(): Observable<DataObject> {
		return this.api.get<DataObject>(API_REDIRECT_URL);
	}

	verifyAuth(): Observable<boolean> {
		return this.api.get<boolean>(API_VERIFY_AUTH);
	}
}
